<script>
    import { fade } from "svelte/transition";
    import BlockMenuNav from "./block-menus/BlockMenuNav.svelte";
    import DonationBoxMenu from "./block-menus/DonationBoxMenu.svelte";
    export let addTextBlock;
    export let hideBlockMenu;
    export let sectionIndex;
    export let addDonationBoxBlock;
    let showEditBlockMenu = false;
    let menu;

    function showDonationBoxMenu() {
        menu = "donationbox";
        showEditBlockMenu = true;
    }
    function hide() {
        showEditBlockMenu = false;
    }
</script>

<div class="shadow df-add-block-menu" in:fade>
    {#if showEditBlockMenu}
        <BlockMenuNav {menu} {addDonationBoxBlock} {hide} />
    {:else}
    <div style="height: 40px;"></div>
    <div class="d-flex justify-content-center">
        <div class="add-content-button" on:click={addTextBlock}>
            <i class='bx bx-text'></i>
            <div class="add-content-button-text" on:click={addTextBlock}>Text</div>
        </div>
        <div style="width:10px;"></div>
        <div class="add-content-button" on:click={showDonationBoxMenu}>
            <i class='bx bx-coin'></i>
            <div class="add-content-button-text" on:click={showDonationBoxMenu}>Donation Box</div>
        </div>
        <div style="width:10px;"></div>
        <div class="add-content-button" on:click={showDonationBoxMenu}>
            <i class='bx bx-file-blank'></i>
            <div class="add-content-button-text" on:click={showDonationBoxMenu}>Gift Card</div>
        </div>
    
    </div>
    <div style="height: 40px;"></div>
        
    {/if}

    <div>
        <div
            on:click={hideBlockMenu}
            class="btn btn-default btn-block btn-sm">Cancel</div
        >
    </div>
</div>

<style>
    .add-content-button {
        width: 80px;
        height: 80px;
        display:flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 10px;
        border-radius: 7px;
        background: #f9f9f9;
        cursor: pointer;
    }
    .add-content-button i {
        font-size: 2rem;
    }
    .add-content-button:hover {
        background: #e8e8e8;
    }
    .df-add-block-menu {
        text-align: center;
        width: 400px;
        padding: 20px 20px 10px 20px;
        border-radius: 7px;
        margin: 0 auto;
        margin-bottom: -30px;
        background: #ffffff;
        z-index: 999;
    }
</style>
